export const STORE_FETCHED_CATEGORIES = 'STORE_FETCHED_CATEGORIES'
export const CATEGORIES_LOADED = 'CATEGORIES_LOADED'

export const STORE_FETCHED_PAGES = 'STORE_FETCHED_PAGES'
export const STORE_FETCHED_FRONTPAGE = 'STORE_FETCHED_FRONTPAGE'
export const PAGES_LOADED = 'PAGES_LOADED'
export const PAGES_FRONTPAGE_LOADED = 'PAGES_FRONTPAGE_LOADED'

export const STORE_FETCHED_POSTS = 'STORE_FETCHED_POSTS'
export const POSTS_LOADED = 'POSTS_LOADED'

export const STORE_FETCHED_FEATURES = 'STORE_FETCHED_FEATURES'
export const STORE_SELECT_FEATURE_BY_POST_SLUG = 'STORE_SELECT_FEATURE_BY_POST_SLUG'
export const FEATURES_LOADED = 'FEATURES_LOADED'
export const FEATURE_SELECTED = 'FEATURE_SELECTED'
export const STORE_VISIBLE_FEATURES = 'STORE_VISIBLE_FEATURES'

export const STORE_FETCHED_USER = 'STORE_FETCHED_USER'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'

export const INCREMENT_LOADING_PROGRESS = 'INCREMENT_LOADING_PROGRESS'
export const RESET_LOADING_PROGRESS = 'RESET_LOADING_PROGRESS'
export const VISIBLE_DRAWER = 'VISIBLE_DRAWER'
export const VISIBLE_SINGLE = 'VISIBLE_SINGLE'
